module.exports = __webpack_public_path__ + "img/icon-users.e3dcba31.svg";